import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";

import { LayoutContext, SCREENTYPE } from "../../hooks/useLayout";
import { CategoryContext } from "@/hooks/useCategories";
import {
    findChildsCategoriesHierachy,
    getCategoryFromId,
    getCategoryParentId,
} from "../../utils/categories";

import UiDesktop from "./uiDesktop";
import UiMobile from "./uiMobile";

import styles from "./listeCategories.module.scss";

type PropTypes = {
    categoryId: number;
    className?: string;
};

const ListeCategories = ({ categoryId, className = "" }: PropTypes) => {
    const { screenType } = useContext(LayoutContext);
    const categories = useContext(CategoryContext);

    const [isMobile, setIsMobile] = useState(true);

    const categoryParentId = getCategoryParentId(categoryId, categories);
    const categoryParent = getCategoryFromId(categoryParentId, categories);
    const categoriesHierachy = findChildsCategoriesHierachy(
        categoryId,
        categories,
        categoryParentId,
    );

    useEffect(() => {
        setIsMobile(screenType == SCREENTYPE.MOBILE);
    }, []);

    if (!categoriesHierachy || !categoryParent) {
        return null;
    }

    return (
        <div
            data-component="ListeCategories"
            className={classNames(styles.me, {
                [className]: className,
            })}
        >
            {isMobile ? (
                <UiMobile
                    categoriesHierachy={categoriesHierachy}
                    categoryId={categoryId}
                    categoryParent={categoryParent}
                />
            ) : (
                <UiDesktop
                    categoriesHierachy={categoriesHierachy}
                    categoryId={categoryId}
                    categoryParent={categoryParent}
                />
            )}
        </div>
    );
};

export default ListeCategories;
